import { render, staticRenderFns } from "./createOrganization.vue?vue&type=template&id=7df67ce2&"
import script from "./createOrganization.vue?vue&type=script&lang=ts&"
export * from "./createOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createOrganization.vue"
export default component.exports